<div class="sun"></div>
<div class="moon"></div>
<div class="stepper"></div>